var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"group"},[_c('div',{ref:"content",staticClass:"groupContent",style:(`max-width: ${_vm.maxWidth}px`)},_vm._l((_vm.group),function(item){return _c('Party',{key:item.partyId,attrs:{"item":item,"size":_vm.tokenSize},nativeOn:{"click":function($event){return _vm.onClickParty()}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }